module.exports = __webpack_public_path__ + "img/transferVal.fc87a460.svg";